import React from 'react'

const LeftArrowIcon: React.FC = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="BiLeftArrowAlt">
                <path id="Vector" d="M12.7069 17.293L8.41394 13H17.9999V11H8.41394L12.7069 6.70703L11.2929 5.29303L4.58594 12L11.2929 18.707L12.7069 17.293Z" fill="#4A2C2A" />
            </g>
        </svg>
    )
}

export default LeftArrowIcon;